module.exports = __webpack_public_path__ + "img/zaltbommel-logo.b7990608.webp";